import { lazy } from 'react';
import BasicHeaderLayout from '@/layout/basic-header-layout';
import Loadable from '@/components/Loadable';

const InquiryPage = Loadable(
	lazy(() => import('@/pages/inquiry/inquiry-page'))
);

// --------------------------------

const BasicHeaderRoutes = {
	path: '/',
	element: <BasicHeaderLayout />,
	children: [
		{
			path: 'inquiry',
			element: <InquiryPage />
		}
	]
};

export default BasicHeaderRoutes;
